(function () {
  'use strict';
  var root = document.querySelector('[data-cn]');
  if (!root) return;
  function qa(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function fmt(s) { s = Math.max(0, Math.floor(s || 0)); var r = s % 60; return Math.floor(s / 60) + ':' + (r < 10 ? '0' : '') + r; }

  var current = null;
  function bindPlayer(btn, audio, onTime) {
    btn.setAttribute('aria-pressed', 'false');
    btn.addEventListener('click', function () {
      if (audio.paused) {
        if (current && current !== audio) current.pause();
        current = audio;
        var pr = audio.play();
        if (pr && pr.catch) pr.catch(function () {});
      } else {
        audio.pause();
      }
    });
    audio.addEventListener('play', function () { btn.classList.add('is-playing'); btn.setAttribute('aria-pressed', 'true'); });
    audio.addEventListener('pause', function () { btn.classList.remove('is-playing'); btn.setAttribute('aria-pressed', 'false'); });
    audio.addEventListener('ended', function () { audio.currentTime = 0; });
    if (onTime) audio.addEventListener('timeupdate', function () { onTime(audio.currentTime, audio.duration); });
  }

  var heroAudio = root.querySelector('[data-cn-audio]');
  var heroBtn = root.querySelector('[data-cn-play]');
  var bars = qa('[data-cn-wave] span');
  var elapsed = root.querySelector('[data-cn-elapsed]');
  function paint(t, d) {
    var n = d ? Math.round((t / d) * bars.length) : 0;
    bars.forEach(function (b, i) { b.classList.toggle('is-played', i < n); });
    if (elapsed) elapsed.textContent = fmt(t);
  }
  if (heroAudio && heroBtn) bindPlayer(heroBtn, heroAudio, paint);

  qa('[data-cn-ex]').forEach(function (btn) {
    var a = new Audio();
    a.preload = 'none';
    a.src = btn.getAttribute('data-src');
    bindPlayer(btn, a);
  });

  var chips = qa('[data-cn-occ]');
  var radios = qa('.cn-radios input');
  var h1 = root.querySelector('[data-cn-h1]');
  var nameEl = root.querySelector('[data-cn-name]');
  var metaEl = root.querySelector('[data-cn-meta]');
  var durEl = root.querySelector('[data-cn-dur]');
  function setOcc(k, fromRadio) {
    var chip = null;
    chips.forEach(function (c) {
      var on = c.getAttribute('data-cn-occ') === k;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) chip = c;
    });
    if (!fromRadio) radios.forEach(function (r) { r.checked = r.value === k; });
    if (!chip) return;
    var nm = chip.getAttribute('data-name');
    if (h1) h1.textContent = chip.getAttribute('data-h1');
    if (nameEl) nameEl.textContent = nm;
    if (metaEl) metaEl.textContent = chip.getAttribute('data-meta');
    if (durEl) durEl.textContent = chip.getAttribute('data-dur');
    if (heroBtn) heroBtn.setAttribute('aria-label', 'Ascolta la canzone di ' + nm);
    var src = chip.getAttribute('data-src');
    if (heroAudio && heroAudio.getAttribute('src') !== src) {
      heroAudio.pause();
      heroAudio.setAttribute('src', src);
      paint(0, 0);
    }
  }
  chips.forEach(function (c) { c.addEventListener('click', function () { setOcc(c.getAttribute('data-cn-occ')); }); });
  radios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) setOcc(r.value, true); }); });
  var MAP = { natale: 'Natale', nanna: 'Ninna nanna', ninnananna: 'Ninna nanna', compleanno: 'Compleanno' };
  try {
    var q = (new URLSearchParams(window.location.search).get('occ') || '').toLowerCase();
    if (MAP[q]) setOcc(MAP[q]);
  } catch (e) {}

  var sticky = root.querySelector('[data-cn-sticky]');
  var watch = qa('.cn-left .cn-cta, #crea, .cn-final');
  if (sticky && watch.length && 'IntersectionObserver' in window) {
    var seen = [];
    sticky.classList.add('is-hidden');
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        var i = seen.indexOf(x.target);
        if (x.isIntersecting && i < 0) seen.push(x.target);
        if (!x.isIntersecting && i > -1) seen.splice(i, 1);
      });
      sticky.classList.toggle('is-hidden', seen.length > 0);
    }, { threshold: 0.1 });
    watch.forEach(function (t) { io.observe(t); });
  }

  var form = root.querySelector('[data-cn-form]');
  if (!form) return;
  form.noValidate = true;
  var submit = form.querySelector('[data-cn-submit]');
  var label = form.querySelector('[data-cn-label]');
  var labelText = label ? label.textContent : '';
  var ts = form.querySelector('[data-cn-ts]');
  var fields = qa('[data-cn-msg]', form);
  function tidy(s) { return s.trim().split(' ').filter(Boolean).join(' '); }
  function check(el, fix) {
    var msg = '';
    if (el.type === 'checkbox') {
      if (!el.checked) msg = el.getAttribute('data-cn-msg');
    } else {
      if (fix) el.value = tidy(el.value);
      var val = el.value.trim();
      if (!val) msg = el.getAttribute('data-cn-msg');
      else if (el.type === 'number') {
        var n = Number(val);
        if (isNaN(n) || n < 0 || n > 14) msg = 'Scrivi un’età tra 0 e 14 anni.';
      }
    }
    var err = document.getElementById(el.id + '-err');
    if (msg) {
      el.setAttribute('aria-invalid', 'true');
      if (err) { err.textContent = msg; err.hidden = false; el.setAttribute('aria-describedby', err.id); }
    } else {
      el.removeAttribute('aria-invalid');
      if (err) { err.textContent = ''; err.hidden = true; }
    }
    return !msg;
  }
  fields.forEach(function (el) {
    el.addEventListener(el.type === 'checkbox' ? 'change' : 'input', function () { if (el.hasAttribute('aria-invalid')) check(el, false); });
  });
  function ready() { if (submit) submit.disabled = false; if (label) label.textContent = labelText; }
  window.addEventListener('pageshow', ready);
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var first = null;
    fields.forEach(function (el) { if (!check(el, true) && !first) first = el; });
    if (first) { first.focus(); return; }
    if (ts) ts.value = new Date().toISOString();
    if (submit) submit.disabled = true;
    if (label) label.textContent = 'Un attimo…';
    var add = (form.getAttribute('action') || '/cart/add') + '.js';
    var clear = add.replace('/add.js', '/clear.js');
    var body = new FormData(form);
    fetch(clear, { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function () { return fetch(add, { method: 'POST', headers: { Accept: 'application/json' }, body: body }); })
      .then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = '/checkout'; })
      .catch(function () { HTMLFormElement.prototype.submit.call(form); });
  });
})();
